import {Modal, Col, Tag, Divider} from "antd";
import {useFormik} from "formik";
import moment from "moment";
import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import * as yup from "yup";
import * as Sentry from "@sentry/react";
import {useStore} from "../../../../hooks/useStore";
import {CourierFilter} from "components/_defaultComponents/FilterComponents";

const ShiftCourierUpdateModal = ({shift, visibility, onCancel}) => {
    const {t} = useTranslation(["shiftManagement"]);
    const store = useStore();
    const [confirmLoading, setConfirmLoading] = useState();

    const formik = useFormik({
        initialValues: {id: shift?._id?.toString(), courierId: shift?.courier?._id?.toString()},
        validationSchema: yup.object().shape({
            id: yup.string().required()
        }),
        enableReinitialize: true,
        onSubmit: async values => {
            setConfirmLoading(true);
            try {
                const id = values.id;
                const courierId = values.courierId;
                await store.shiftStore.updateShiftCourier({id, courierId});
                onCancel(true);
            } catch (error) {
                Sentry.captureException(error);
            } finally {
                setConfirmLoading(false);
            }
        }
    });

    const {values, handleSubmit, setFieldValue} = formik;

    const onChangeCourier = value => {
        setFieldValue("courierId", value);
    };

    return (
        <Modal
            title={t("actions.updateShiftCourier", {ns: "shiftManagement"})}
            visible={visibility}
            onCancel={() => {
                onCancel(false);
            }}
            onOk={handleSubmit}
            confirmLoading={confirmLoading}
            okText={t("modal.saveButton", {ns: "common"})}
            cancelText={t("modal.cancelButton2", {ns: "common"})}
        >
            {shift && (
                <>
                    <Col>
                        <p>
                            <b>{t("fields.date", {ns: "common"})}</b> :{" "}
                            {!shift.date ? "-" : moment(shift?.date).format("DD.MM.YYYY")}
                        </p>
                        <p>
                            <b>{t("fields.company", {ns: "common"})}</b> :{" "}
                            {!shift.company ? "-" : shift?.company?.companyName}
                        </p>
                        <p>
                            <b>{t("fields.subcompany", {ns: "common"})}</b> :{" "}
                            {!shift.subcompany ? "-" : shift?.subcompany?.name}
                        </p>
                        <p>
                            <b>{t("fields.courier", {ns: "common"})}</b> :{" "}
                            {!shift.courier || !shift?.courier?.fullname ? (
                                <Tag>Boş Vardiya</Tag>
                            ) : (
                                shift?.courier?.fullname
                            )}
                        </p>
                    </Col>
                    <Divider />
                    <Col>
                        <h4>{t("fields.courier", {ns: "common"})}</h4>
                        <CourierFilter
                            allowClear
                            hideTitle={true}
                            value={values?.courierId}
                            onChange={onChangeCourier}
                            selectMarginBottom="0px"
                            initialOptions={shift?.courier ? [shift?.courier] : []}
                        />
                    </Col>
                </>
            )}
        </Modal>
    );
};

export default ShiftCourierUpdateModal;
